import { Task } from "../../bryntum-lib/models/Task";
import { Resource } from "../../bryntum-lib/models/Resource";
import { STORE_KEYS } from "./StoreKeys.jsx";

export const INCENTIVE_FILTER_ENTITY_TYPES = {
  TASK: "task",
  RESOURCE: "resource"
};

export const INCENTIVE_FILTER_STORE_CONFIG_BY_FIELD_MAP = {
  [INCENTIVE_FILTER_ENTITY_TYPES.TASK]: {
    [Task.getFieldDefinition("tagsId").dataSource]: {
      storeKey: STORE_KEYS.taskTagValuesStore,
      recordKey: "tagValue"
    },
    [Task.getFieldDefinition("categoryId").dataSource]: {
      storeKey: STORE_KEYS.taskTagValuesStore,
      recordKey: "tagValue"
    },
    [Task.getFieldDefinition("statusId").dataSource]: {
      storeKey: STORE_KEYS.taskTagValuesStore,
      recordKey: "tagValue"
    },
    [Task.getFieldDefinition("phaseId").dataSource]: {
      storeKey: STORE_KEYS.taskTagValuesStore,
      recordKey: "tagValue"
    },
    [Task.getFieldDefinition("teamId").dataSource]: {
      storeKey: STORE_KEYS.boardTeamsStore,
      recordKey: "name"
    },
  },
  [INCENTIVE_FILTER_ENTITY_TYPES.RESOURCE]: {
    [Resource.getFieldDefinition("typeId").dataSource]: {
      storeKey: STORE_KEYS.resourceTypeStore,
      recordKey: "description"
    },
    [Resource.getFieldDefinition("tagsId").dataSource]: {
      storeKey: STORE_KEYS.resourceTagValuesStore,
      recordKey: "tagValue"
    },
    [Resource.getFieldDefinition("categoryId").dataSource]: {
      storeKey: STORE_KEYS.resourceTagValuesStore,
      recordKey: "tagValue"
    },
    [Resource.getFieldDefinition("statusId").dataSource]: {
      storeKey: STORE_KEYS.resourceTagValuesStore,
      recordKey: "tagValue"
    },
    [Resource.getFieldDefinition("teamId").dataSource]: {
      storeKey: STORE_KEYS.boardTeamsStore,
      recordKey: "name"
    },
  }
}

export const TASK_FILTER_FIELD_OPTIONS = [
  {
    label: "Tag",
    value: Task.getFieldDefinition("tagsId").dataSource
  },
  {
    label: "Category",
    value: Task.getFieldDefinition("categoryId").dataSource
  },
  {
    label: "Status",
    value: Task.getFieldDefinition("statusId").dataSource
  },
  {
    label: "Phase",
    value: Task.getFieldDefinition("phaseId").dataSource
  },
  {
    label: "Team",
    value: Task.getFieldDefinition("teamId").dataSource
  }
];

export const RESOURCE_FILTER_FIELD_OPTIONS = [
  {
    label: "Type",
    value: Resource.getFieldDefinition("typeId").dataSource
  },
  {
    label: "Tag",
    value: Resource.getFieldDefinition("tagsId").dataSource
  },
  {
    label: "Category",
    value: Resource.getFieldDefinition("categoryId").dataSource
  },
  {
    label: "Status",
    value: Resource.getFieldDefinition("statusId").dataSource
  },
  {
    label: "Team",
    value: Resource.getFieldDefinition("teamId").dataSource
  }
];

export const TASK_TAB_KEYS_BY_FIELD = {
  [Task.getFieldDefinition("tagsId").dataSource]: "",
  // SETTING_KEYS.TASK_TAGS,
  [Task.getFieldDefinition("categoryId").dataSource]: "",
  // SETTING_KEYS.TASK_CATEGORIES,
  [Task.getFieldDefinition("statusId").dataSource]: "",
  // SETTING_KEYS.TASK_STATUSES,
  [Task.getFieldDefinition("phaseId").dataSource]: "",
  // SETTING_KEYS.TASK_PHASE
};

export const RESOURCE_TAB_KEYS_BY_FIELD = {
  [Resource.getFieldDefinition("typeId").dataSource]: "",
  // SETTING_KEYS.RESOURCE_TYPES,
  [Resource.getFieldDefinition("tagsId").dataSource]: "",
  // SETTING_KEYS.RESOURCE_TAGS,
  [Resource.getFieldDefinition("categoryId").dataSource]: "",
  // SETTING_KEYS.RESOURCE_CATEGORIES,
  [Resource.getFieldDefinition("statusId").dataSource]: "",
  // SETTING_KEYS.RESOURCE_STATUSES
};

export const INCENTIVE_FILTER_OPTIONS_BY_ENTITY_TYPE = {
  [INCENTIVE_FILTER_ENTITY_TYPES.TASK]: TASK_FILTER_FIELD_OPTIONS,
  [INCENTIVE_FILTER_ENTITY_TYPES.RESOURCE]: RESOURCE_FILTER_FIELD_OPTIONS
};

export const INCENTIVE_FILTER_OPERATORS = {
  IS: "IS",
  IS_NOT: "IS_NOT"
};

export const INCENTIVE_FILTER_OPERATOR_VALUES = {
  [INCENTIVE_FILTER_OPERATORS.IS]: "Is",
  [INCENTIVE_FILTER_OPERATORS.IS_NOT]: "Is Not"
};

export const INCENTIVE_FILTER_BOOLEAN_OPERATORS = {
  AND: "AND",
  OR: "OR"
};

export const INCENTIVE_TYPES = {
  OUTCOME: 1,
  EFFORT: 2,
  SPOT: 3,
  INSPECTION: 4,
};

export const INCENTIVE_TYPES_VALUES = {
  [INCENTIVE_TYPES.OUTCOME]: "Outcome",
  [INCENTIVE_TYPES.EFFORT]: "Effort",
  [INCENTIVE_TYPES.SPOT]: "Spot",
  [INCENTIVE_TYPES.INSPECTION]: "Inspection",
};

export const OUTCOME_INCENTIVE_STATUS = {
  ACTIVE: 1,
  PAUSED: 2,
  INACTIVE: 3
};

export const OUTCOME_INCENTIVE_STATUS_VALUES = {
  [OUTCOME_INCENTIVE_STATUS.ACTIVE]: "Active",
  [OUTCOME_INCENTIVE_STATUS.PAUSED]: "Paused",
  [OUTCOME_INCENTIVE_STATUS.INACTIVE]: "Inactive",
};

export const INCENTIVE_PERMISSION_KEYS = {
  INCENTIVE_MANAGERS: "incentiveManagers",
  POINT_APPROVERS: "pointApprovers",
  POINT_AWARDERS: "pointAwarders",
  POINT_ARCHIVERS: "pointArchivers",
  POINT_DELETERS: "pointDeleters",
  INCENTIVE_VIEW: "incentiveView",
  PENDING_POINTS_VIEW: "pendingPointsViewGrant",
  APPROVED_POINTS_VIEW: "approvedPointsViewGrant",
  DENIED_POINTS_VIEW: "deniedPointsViewGrant",
  AWARDED_POINTS_VIEW: "awardedPointsViewGrant"
};

export const INCENTIVE_POINT_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  DENIED: 3,
  AWARDED: 4,
};

export const INCENTIVE_POINT_STATUS_VALUES = {
  [INCENTIVE_POINT_STATUS.PENDING]: "Pending",
  [INCENTIVE_POINT_STATUS.APPROVED]: "Approved",
  [INCENTIVE_POINT_STATUS.DENIED]: "Denied",
  [INCENTIVE_POINT_STATUS.AWARDED]: "Awarded",
};